export default __webpack_public_path__ + "static/matcap7-a6a70be4983255453d8ce0296cae5bc4.jpeg";